// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ky9Q","colMin":"styles_colMin__115FX"};